import React, { useState } from "react";
import clsx from "clsx";
import { Accordion } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as outstandingSelectors from "../../../../selectors/outstanding";
import CustomPriceSpan from "../../../../components/CustomPriceSpan";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import Constants from "../../../../constants";
import Helper from "../../../../utils/Helper";
import {
  getOutstandingStatementOutstandingAmount,
  getOutstandingStatementTotalOutstandingAmountFullText, getOutstandingStatementTotalOutstandingAmountValue
} from "../../../../selectors/outstanding";
function OutstandingPositionPurchaseContractSection({
                            title,
                            data,
                            selectedCurrencyText,
                            loading = false,
                          }) {
  const [activeKey, setActiveKey] = useState(["0"]);
  const [transactionDateOrderBy, setTransactionDateOrderBy] = useState(false);
  const [stockNameOrderBy, setStockNameOrderBy] = useState(null);

  const handleAccordionClick = (eventKey) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const totalSum = _.sumBy(data, (item) =>
    outstandingSelectors.getOutstandingStatementTotalOutstandingAmountValue(item),
  );

  const totalOsSum = _.sumBy(data, (item) =>
    outstandingSelectors.getOutstandingStatementOutstandingAmountValue(item),
  );

  const totalAccISum = _.sumBy(data, (item) =>
    outstandingSelectors.getOutstandingStatementAccureInterestValue(item),
  );

  const orderByData = Helper.orderByData(data,transactionDateOrderBy,stockNameOrderBy)


  return (
    <div className="mt-4">
      <div className={clsx("custom-table-info-container padding-12px")}>
        <Accordion
          activeKey={activeKey}
          onSelect={handleAccordionClick}
          flush
          alwaysOpen
        >
          <Accordion.Item key="0" eventKey="0">
            <Accordion.Header className="outstanding-accord-header m-0">
              <h3 className={clsx("text-center")}>{title}</h3>
            </Accordion.Header>
            <Accordion.Body>
              <Table responsive="xxl">
                {!loading && !_.isEmpty(orderByData) ? (
                  <thead>
                  <tr
                    className={
                      "custom-table-setoff-styled styled-outstanding-table"
                    }
                  >
                    <th style={{ width: 120, verticalAlign: "bottom" }}>
                      <div
                        className="pointer"
                        onClick={() =>{
                          setStockNameOrderBy(null);

                          setTransactionDateOrderBy((prev) => {
                            return !prev;
                          })
                        }
                        }
                      >
                        Date
                        <FontAwesomeIcon
                          className="mx-2"
                          icon={faSort}
                        ></FontAwesomeIcon>
                      </div>
                    </th>
                    <th style={{ width: 200, verticalAlign: "bottom" }}>
                      Reference No
                    </th>
                    <th style={{ width: 100, verticalAlign: "bottom" }}>
                      Stock Code
                    </th>
                    <th style={{ width: 140, verticalAlign: "bottom" }}>
                      <div
                        className="pointer"
                        onClick={() => {
                          setTransactionDateOrderBy(false);
                          setStockNameOrderBy((prev) => {
                            if (prev === Constants.ORDER_BY_ASC) {
                              return Constants.ORDER_BY_DESC;
                            }
                            if (prev === Constants.ORDER_BY_DESC) {
                              return Constants.ORDER_BY_ASC;
                            }
                            return Constants.ORDER_BY_ASC;
                          });
                        }}
                      >
                        Stock Name
                        <FontAwesomeIcon
                          className="mx-2"
                          icon={faSort}
                        ></FontAwesomeIcon>
                      </div>
                    </th>
                      <th style={{ width: 100, verticalAlign: "bottom" }}>
                        Quantity
                      </th>
                      <th style={{ width: 120, verticalAlign: "bottom" }}>
                        Transaction Price
                      </th>
                      <th style={{ width: 120, verticalAlign: "bottom" }}>
                        Exchange Rate
                      </th>
                      <th style={{ width: 150, verticalAlign: "bottom" }}>
                        Outstanding Amount
                      </th>
                      <th style={{ width: 120, verticalAlign: "bottom" }}>
                        Accrued Interest
                      </th>
                      <th style={{ width: 150, verticalAlign: "bottom" }}>
                        Total Outstanding Amount
                      </th>
                      <th style={{ width: 70, verticalAlign: "bottom" }}>
                        Aging
                      </th>
                      <th style={{ width: 100, verticalAlign: "bottom" }}>
                        Due Date
                      </th>
                  </tr>
                  </thead>
                  ) : (
                  false
                  )}
                <tbody>
                {!_.isEmpty(orderByData) ? (
                  _.map(orderByData, (trustMoneyDataList, index) => {
                    const contractRefer =
                      outstandingSelectors.getOutstandingStatementContractReference(
                        trustMoneyDataList
                      );
                    const dueDate =
                      outstandingSelectors.getOutstandingStatementDueDate(
                        trustMoneyDataList
                      );
                    const exchangeRate =
                      outstandingSelectors.getOutstandingStatementExchangeRate(
                        trustMoneyDataList
                      );
                    const outstandingQuantity =
                      outstandingSelectors.getOutstandingStatementOutstandingQuantity(
                        trustMoneyDataList
                      );
                      const outstandingAmount =
                        outstandingSelectors.getOutstandingStatementOutstandingAmount(
                          trustMoneyDataList,
                        );
                      const stockCode =
                        outstandingSelectors.getOutstandingStatementStockCode(
                          trustMoneyDataList,
                        );
                      const stockName =
                        outstandingSelectors.getOutstandingStatementStockName(
                          trustMoneyDataList,
                        );
                      const aging =
                        outstandingSelectors.getOutstandingStatementAging(
                          trustMoneyDataList,
                        );
                      const transactionPriceText =
                        outstandingSelectors.getOutstandingStatementTransactionPriceFullText(
                          trustMoneyDataList,
                        );
                      const transactionDate =
                        outstandingSelectors.getOutstandingStatementTransactionDate(
                          trustMoneyDataList,
                        );
                      const accureInterestFullText =
                        outstandingSelectors.getOutstandingStatementAccureInterestFullText(
                          trustMoneyDataList,
                        );
                      const totalOutstandingAmountText =
                        outstandingSelectors.getOutstandingStatementTotalOutstandingAmountFullText(
                          trustMoneyDataList,
                        );
                      const totalOutstandingBalText =
                        outstandingSelectors.getOutstandingStatementTotalOutstandingAmountFullText(
                          trustMoneyDataList,
                        );
                      return (
                        <tr key={index}>
                          <td style={{ width: 120 }}>{transactionDate}</td>
                          <td style={{ width: 200 }}>{contractRefer}</td>
                          <td style={{ width: 100 }}>{stockCode}</td>
                          <td style={{ width: 120 }}>{stockName}</td>
                          <td style={{ width: 100 }}>{outstandingQuantity}</td>
                          <td style={{ width: 120 }}>{transactionPriceText}</td>
                          <td style={{ width: 120 }}>{exchangeRate}</td>
                          <td style={{ width: 150 }}>{outstandingAmount}</td>
                          <td style={{ width: 120 }}>
                            {accureInterestFullText}
                          </td>
                          <td style={{ width: 150 }}>
                            {totalOutstandingBalText}
                          </td>
                          <td style={{ width: 70 }}>
                            {aging > 0 ? "T" + aging : "-"}
                          </td>
                          <td style={{ width: 100 }}>{dueDate}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={12}>
                        <EmptyItemView extraCss={{ height: "100px" }} />
                        <LoadingOverlay loading={loading}></LoadingOverlay>
                      </td>
                    </tr>
                  )}
                </tbody>
                {!loading && !_.isEmpty(data) ? (
                  <tfoot>
                    <tr>
                      <th colSpan={9} className={clsx("text-end")}>
                        <span className="pe-2">Summary:</span>
                      </th>
                      <th>
                        <span>
                          {selectedCurrencyText}{" "}
                          <CustomPriceSpan value={totalSum} />
                        </span>
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                  </tfoot>
                ) : (
                  false
                )}
              </Table>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}

export default OutstandingPositionPurchaseContractSection;
